import lodash from 'lodash';

import { composeReducers } from 'common/util/composeReducers';

import {
    TASK_COUNT_LOADED,
    TASKS_LOADING,
    TASKS_UNLOADED,
    SDFA_TASKS_LOADED,
    DOA_TASKS_LOADED,
    EVENT_TASKS_LOADED
} from '../actions/tasks';

export function queryingTasks(state, action) {
    if (!action || action.type !== TASKS_LOADING) {
        return state;
    }

    const newState = lodash.clone(state);
    lodash.set(newState, 'study.tasks.loading', action.payload);

    return newState;
}

export function taskCountLoaded(state, action) {
    if (!action || action.type !== TASK_COUNT_LOADED) {
        return state;
    }

    let newState = lodash.clone(state);

    const { status, count } = action.payload;

    if (status === 'pending') {
        lodash.set(newState, 'study.tasks.pending.count', count);
    }

    if (status === 'completed') {
        lodash.set(newState, 'study.tasks.completed.count', count);
    }

    return newState;
}

export function sdfaTasksLoaded(state, action) {
    if (!action || action.type !== SDFA_TASKS_LOADED) {
        return state;
    }

    let newState = lodash.clone(state);

    const { status, tasks } = action.payload;

    if (status === 'pending') {
        lodash.set(newState, 'study.tasks.pending.documents', tasks);
    }

    if (status === 'completed') {
        lodash.set(newState, 'study.tasks.completed.documents', tasks);
    }

    return newState;
}

export function eventTasksLoaded(state, action) {
    if (!action || action.type !== EVENT_TASKS_LOADED) {
        return state;
    }

    let newState = lodash.clone(state);

    const { status, tasks } = action.payload;

    if (status === 'pending') {
        lodash.set(newState, 'study.tasks.pending.events', tasks);
    }

    if (status === 'completed') {
        lodash.set(newState, 'study.tasks.completed.events', tasks);
    }

    return newState;
}

export function doaTasksLoaded(state, action) {
    if (!action || action.type !== DOA_TASKS_LOADED) {
        return state;
    }

    let newState = lodash.clone(state);

    const { status, tasks } = action.payload;

    if (status === 'pending') {
        lodash.set(newState, 'study.tasks.pending.delegations', tasks);
    }

    if (status === 'completed') {
        lodash.set(newState, 'study.tasks.completed.delegations', tasks);
    }

    return newState;
}

export function tasksUnloaded(state, action) {
    if (!action || action.type !== TASKS_UNLOADED) {
        return state;
    }

    let newState = lodash.clone(state);

    lodash.unset(newState, 'study.tasks.pending.documents');
    lodash.unset(newState, 'study.tasks.completed.documents');
    lodash.unset(newState, 'study.tasks.pending.delegations');
    lodash.unset(newState, 'study.tasks.completed.delegations');

    return newState;
}

export default composeReducers(
    eventTasksLoaded,
    queryingTasks,
    taskCountLoaded,
    sdfaTasksLoaded,
    doaTasksLoaded,
    tasksUnloaded,
);
